namespace OSF {
  export enum ClientMode {
    ReadOnly = 0,
    ReadWrite = 1,
  }
  export enum OsfControlType {
    DocumentLevel = 0,
    ContainerLevel = 1,
  }

  /// <summary>
  /// OfficeAppContext is the class for host app to provide information for MOE to intialize.
  /// </summary>
  /// <accessibility>public</accessibility>
  /// <param name="id">The solutionId for the MOE (SharePoint app) (Type: String)</param>
  /// <param name="appName">The name of the host application (Type: OSF.AppName) </param>
  /// <param name="appVersion">The version of the host application. For example: "15"(Type: String) </param>
  /// <param name="appUILocale">UILocale of the host application. For example: "en-us"(Type: String) </param>
  /// <param name="dataLocale">Data locale of the host application document. For example: "zh-cn"(Type: String) </param>
  /// <param name="docUrl">Url of the host application document. (Type: String) </param>
  /// <param name="clientMode">The mode of the host application document. (Type: OSF.ClientMode) </param>
  /// <param name="settings">The settings of the MOE. (Type: Object) </param>
  /// <param name="reason">The reason for the MOE intialization.  (Type: Microsoft.Office.WebExtension.InitializationReason) </param>
  /// <param name="osfControlType">The Agave Type.  (Type: OSF.OsfControlType) </param>
  /// <param name="eToken">The token for current user.  (Type: String) </param>
  /// <param name="correlationId">The correlation id.  (Type: String) </param>
  /// <param name="appInstanceId">An unique Id for this App instance.  (Type: String) </param>
  /// <param name="touchEnabled">Is the host using touch input. (Type: Boolean)</param>
  /// <param name="commerceAllowed">Is the app allowed to show commerce UI at this endpoint. (Type: Boolean)</param>
  /// <param name="appMinorVersion">The minor version of the app. (Type: String)</param>
  /// <param name="requirementMatrix">JSON serialized string containing supported API. (Type: String)</param>
  /// <param name="hostCustomMessage">Allows the host to pass a custom message to office.js telemetry. (Type: String)</param>
  /// <param name="hostFullVersion">The major/minor/revision/sequence version of the host. (Type: String)</param>
  /// <param name="clientWindowHeight">The height of the host window. (Type: Integer)</param>
  /// <param name="clientWindowWidth">The width of the host window. (Type: Integer)</param>
  /// <param name="addinName">The name of current addin (Type: String)</param>
  /// <param name="appDomains">The app domain list of the agave (Type: Array)</param>
  /// <param name="dialogRequirementMatrix">JSON serialized string containing dialog requirements. (Type: String)</param>
  /// <param name="featureGates">Map of all feature gate and their values for this solution (Type: Object)"</param>
  /// <param name="officeTheme">Current OfficeThemeInfo used by the host (Type: Object)</param>
  /// <param name="initialDisplayMode">Runtime's initial display mode (Type: Integer)</param>
  export let OfficeAppContext = function OSF_OfficeAppContext(
    id,
    appName,
    appVersion,
    appUILocale,
    dataLocale,
    docUrl,
    clientMode,
    settings,
    reason,
    osfControlType,
    eToken,
    correlationId,
    appInstanceId,
    touchEnabled,
    commerceAllowed,
    appMinorVersion,
    requirementMatrix,
    hostCustomMessage,
    hostFullVersion,
    clientWindowHeight,
    clientWindowWidth,
    addinName,
    appDomains,
    dialogRequirementMatrix,
    featureGates,
    officeTheme,
    initialDisplayMode,
    hostSettings,
  ) {
    this._id = id;
    this._appName = appName;
    this._appVersion = appVersion;
    this._appUILocale = appUILocale;
    this._dataLocale = dataLocale;
    this._docUrl = docUrl;
    this._clientMode = clientMode;
    this._settings = settings;
    this._reason = reason;
    this._osfControlType = osfControlType;
    this._eToken = eToken;
    this._correlationId = correlationId;
    this._appInstanceId = appInstanceId;
    this._touchEnabled = touchEnabled;
    this._commerceAllowed = commerceAllowed;
    this._appMinorVersion = appMinorVersion;
    this._requirementMatrix = requirementMatrix;
    this._hostCustomMessage = hostCustomMessage;
    this._hostFullVersion = hostFullVersion;
    this._isDialog = false;
    this._clientWindowHeight = clientWindowHeight;
    this._clientWindowWidth = clientWindowWidth;
    this._addinName = addinName;
    this._appDomains = appDomains;
    this._dialogRequirementMatrix = dialogRequirementMatrix;
    this._featureGates = featureGates;
    this._officeTheme = officeTheme;
    this._initialDisplayMode = initialDisplayMode;
    this._hostSettings = hostSettings;
    this.get_id = function get_id() {
      return this._id;
    };
    this.get_appName = function get_appName() {
      return this._appName;
    };
    this.get_appVersion = function get_appVersion() {
      return this._appVersion;
    };
    this.get_appUILocale = function get_appUILocale() {
      return this._appUILocale;
    };
    this.get_dataLocale = function get_dataLocale() {
      return this._dataLocale;
    };
    this.get_docUrl = function get_docUrl() {
      return this._docUrl;
    };
    this.get_clientMode = function get_clientMode() {
      return this._clientMode;
    };
    this.get_bindings = function get_bindings() {
      return this._bindings;
    };
    this.get_settings = function get_settings() {
      return this._settings;
    };
    this.get_reason = function get_reason() {
      return this._reason;
    };
    this.get_osfControlType = function get_osfControlType() {
      return this._osfControlType;
    };
    this.get_eToken = function get_eToken() {
      return this._eToken;
    };
    this.get_correlationId = function get_correlationId() {
      return this._correlationId;
    };
    this.get_appInstanceId = function get_appInstanceId() {
      return this._appInstanceId;
    };
    this.get_touchEnabled = function get_touchEnabled() {
      return this._touchEnabled;
    };
    this.get_commerceAllowed = function get_commerceAllowed() {
      return this._commerceAllowed;
    };
    this.get_appMinorVersion = function get_appMinorVersion() {
      return this._appMinorVersion;
    };
    this.get_requirementMatrix = function get_requirementMatrix() {
      return this._requirementMatrix;
    };
    this.get_dialogRequirementMatrix = function get_dialogRequirementMatrix() {
      return this._dialogRequirementMatrix;
    };
    this.get_hostCustomMessage = function get_hostCustomMessage() {
      return this._hostCustomMessage;
    };
    this.get_hostFullVersion = function get_hostFullVersion() {
      return this._hostFullVersion;
    };
    this.get_isDialog = function get_isDialog() {
      return this._isDialog;
    };
    this.get_clientWindowHeight = function get_clientWindowHeight() {
      return this._clientWindowHeight;
    };
    this.get_clientWindowWidth = function get_clientWindowWidth() {
      return this._clientWindowWidth;
    };
    this.get_addinName = function get_addinName() {
      return this._addinName;
    };
    this.get_appDomains = function get_appDomains() {
      return this._appDomains;
    };
    this.get_featureGates = function get_featureGates() {
      return this._featureGates;
    };
    this.get_officeTheme = function get_officeTheme() {
      return this._officeTheme;
    };
    this.get_initialDisplayMode = function get_initialDisplayMode() {
      return this._initialDisplayMode ? this._initialDisplayMode : 0;
    };
    this.get_hostSettings = function get_hostSettings() {
      return this._hostSettings;
    };
  };
  export enum DialogMessageType {
    DialogMessageReceived = 0,
    DialogParentMessageReceived = 1,
    DialogClosed = 12006, // errorCodes.ooeWebDialogClosed
  }

  // Constants that are shared by OsfRuntime.ts and Office.ts
  export enum SharedConstants {
    "NotificationConversationIdSuffix" = "_ntf",
  }

  // ActionId for notification between Agave and Host
  export enum AgaveHostAction {
    "Select" = 0,
    "UnSelect" = 1,
    "CancelDialog" = 2,
    "InsertAgave" = 3,
    "CtrlF6In" = 4,
    "CtrlF6Exit" = 5,
    "CtrlF6ExitShift" = 6,
    "SelectWithError" = 7,
    "NotifyHostError" = 8,
    "RefreshAddinCommands" = 9,
    "PageIsReady" = 10,
    "TabIn" = 11,
    "TabInShift" = 12,
    "TabExit" = 13,
    "TabExitShift" = 14,
    "EscExit" = 15,
    "F2Exit" = 16,
    "ExitNoFocusable" = 17,
    "ExitNoFocusableShift" = 18,
    "MouseEnter" = 19,
    "MouseLeave" = 20,
    "UpdateTargetUrl" = 21,
    "InstallCustomFunctions" = 22,
    "SendTelemetryEvent" = 23,
    "UninstallCustomFunctions" = 24,
    "SendMessage" = 25,
    "LaunchExtensionComponent" = 26,
    "StopExtensionComponent" = 27,
    "RestartExtensionComponent" = 28,
    "EnableTaskPaneHeaderButton" = 29,
    "DisableTaskPaneHeaderButton" = 30,
    "TaskPaneHeaderButtonClicked" = 31,
    "RemoveAppCommandsAddin" = 32,
    "RefreshRibbonGallery" = 33,
    "GetOriginalControlId" = 34,
    "OfficeJsReady" = 35,
    "InsertDevManifest" = 36,
    "InsertDevManifestError" = 37,
    "SendCustomerContent" = 38,
    "KeyboardShortcuts" = 39,
    "OsfControlLoad" = 40,
    "ClickTrust" = 41,
    "CloseSDXDialog" = 42,
    "ResizeSDXDialog" = 43,
    "SendNonStandardEvent" = 44,
    "TriggerAddinDetailPage" = 45,
  }
  export enum HostCallPerfMarker {
    IssueCall = "Agave.HostCall.IssueCall",
    ReceiveResponse = "Agave.HostCall.ReceiveResponse",
    RuntimeExceptionRaised = "Agave.HostCall.RuntimeExecptionRaised",
  }
  export enum InternalPerfMarker {
    DataCoercionBegin = "Agave.HostCall.CoerceDataStart",
    DataCoercionEnd = "Agave.HostCall.CoerceDataEnd", // "Agave.Internal.DataCoercionEnd"
  }
  export enum NestedAppAuthBridgeType {
    None = 0,
    ExecuteApi = 1,
    PostMessage = 2,
  }
  export namespace DDA {
    export enum EventDispId {
      dispidEventMin = 0,
      // DDA
      dispidInitializeEvent = 0,
      dispidSettingsChangedEvent = 1,
      dispidDocumentSelectionChangedEvent = 2,
      dispidBindingSelectionChangedEvent = 3,
      dispidBindingDataChangedEvent = 4,
      dispidDocumentOpenEvent = 5,
      dispidDocumentCloseEvent = 6,
      dispidActiveViewChangedEvent = 7,
      dispidDocumentThemeChangedEvent = 8,
      dispidOfficeThemeChangedEvent = 9,
      dispidDialogMessageReceivedEvent = 10,
      dispidDialogNotificationShownInAddinEvent = 11,
      dispidDialogParentMessageReceivedEvent = 12,
      dispidObjectDeletedEvent = 13,
      dispidObjectSelectionChangedEvent = 14,
      dispidObjectDataChangedEvent = 15,
      dispidContentControlAddedEvent = 16,
      dispidLiveShareStateChangedEvent = 17,
      dispidSuspend = 19,
      dispidResume = 20,
      // Internal events:
      dispidActivationStatusChangedEvent = 32,
      dispidRichApiMessageEvent = 33,
      dispidAppCommandInvokedEvent = 39,
      // Outlook - make sure that these are not already in use by Outlook for other APIs.
      dispidOlkItemSelectedChangedEvent = 46,
      dispidOlkRecipientsChangedEvent = 47,
      dispidOlkAppointmentTimeChangedEvent = 48,
      dispidOlkRecurrenceChangedEvent = 49,
      dispidOlkAttachmentsChangedEvent = 50,
      dispidOlkEnhancedLocationsChangedEvent = 51,
      dispidOlkInfobarClickedEvent = 52,
      // PROJECT SPECIFIC - 56-59 reserved
      dispidTaskSelectionChangedEvent = 56,
      dispidResourceSelectionChangedEvent = 57,
      dispidViewSelectionChangedEvent = 58,
      // CustomXmlPart
      dispidDataNodeAddedEvent = 60,
      dispidDataNodeReplacedEvent = 61,
      dispidDataNodeDeletedEvent = 62,
      dispidEventMax = 63,
    }
    export enum MethodDispId {
      dispidMethodMin = 64,
      // DDA
      dispidGetSelectedDataMethod = 64,
      dispidSetSelectedDataMethod = 65,
      dispidAddBindingFromSelectionMethod = 66,
      dispidAddBindingFromPromptMethod = 67,
      dispidGetBindingMethod = 68,
      dispidReleaseBindingMethod = 69,
      dispidGetBindingDataMethod = 70,
      dispidSetBindingDataMethod = 71,
      dispidAddRowsMethod = 72,
      dispidClearAllRowsMethod = 73,
      dispidGetAllBindingsMethod = 74,
      dispidLoadSettingsMethod = 75,
      dispidSaveSettingsMethod = 76,
      dispidGetDocumentCopyMethod = 77,
      dispidAddBindingFromNamedItemMethod = 78,
      dispidAddColumnsMethod = 79,
      dispidGetDocumentCopyChunkMethod = 80,
      dispidReleaseDocumentCopyMethod = 81,
      dispidNavigateToMethod = 82,
      dispidGetActiveViewMethod = 83,
      dispidGetDocumentThemeMethod = 84,
      dispidGetOfficeThemeMethod = 85,
      dispidGetFilePropertiesMethod = 86,
      dispidClearFormatsMethod = 87,
      dispidSetTableOptionsMethod = 88,
      dispidSetFormatsMethod = 89,
      // OSFJS: Need pre-processor alternative.
      // #ifdef ENABLE_OSFCLIENT_USERIDENTITY
      dispidGetUserIdentityInfoMethod = 92,
      // #endif
      dispidExecuteRichApiRequestMethod = 93,
      dispidAppCommandInvocationCompletedMethod = 94,
      dispidCloseContainerMethod = 97,
      dispidGetAccessTokenMethod = 98,
      dispidGetAuthContextMethod = 99,
      dispidGetLiveShareStateMethod = 100,
      dispidSetLiveShareStateMethod = 101,
      dispidOpenBrowserWindow = 102,
      dispidCreateDocumentMethod = 105,
      dispidInsertFormMethod = 106,
      dispidDisplayRibbonCalloutAsyncMethod = 109,
      // PROJECT SPECIFIC
      //Project method range: 110-127
      dispidGetSelectedTaskMethod = 110,
      dispidGetSelectedResourceMethod = 111,
      dispidGetTaskMethod = 112,
      dispidGetResourceFieldMethod = 113,
      dispidGetWSSUrlMethod = 114,
      dispidGetTaskFieldMethod = 115,
      dispidGetProjectFieldMethod = 116,
      dispidGetSelectedViewMethod = 117,
      dispidGetTaskByIndexMethod = 118,
      dispidGetResourceByIndexMethod = 119,
      dispidSetTaskFieldMethod = 120,
      dispidSetResourceFieldMethod = 121,
      dispidGetMaxTaskIndexMethod = 122,
      dispidGetMaxResourceIndexMethod = 123,
      dispidCreateTaskMethod = 124,
      // CustomXmlPart
      dispidAddDataPartMethod = 128,
      dispidGetDataPartByIdMethod = 129,
      dispidGetDataPartsByNamespaceMethod = 130,
      dispidGetDataPartXmlMethod = 131,
      dispidGetDataPartNodesMethod = 132,
      dispidDeleteDataPartMethod = 133,
      dispidGetDataNodeValueMethod = 134,
      dispidGetDataNodeXmlMethod = 135,
      dispidGetDataNodesMethod = 136,
      dispidSetDataNodeValueMethod = 137,
      dispidSetDataNodeXmlMethod = 138,
      dispidAddDataNamespaceMethod = 139,
      dispidGetDataUriByPrefixMethod = 140,
      dispidGetDataPrefixByUriMethod = 141,
      dispidGetDataNodeTextMethod = 142,
      dispidSetDataNodeTextMethod = 143,
      // New General API
      dispidMessageParentMethod = 144,
      dispidSendMessageMethod = 145,
      dispidExecuteFeature = 146,
      dispidQueryFeature = 147,
      dispidMethodMax = 147,
      dispidGetNestedAppAuthContextMethod = 205,
    }

    // The XDM requires server-side hookups for all events, but bindings and data nodes for custom xml are dynamically created and so they need specific event names for XDM registration
    export let getXdmEventName = function OSF_DDA$GetXdmEventName(id, eventType) {
      if (
        // @ts-ignore TS2339
        eventType == Microsoft.Office.WebExtension.EventType.BindingSelectionChanged ||
        // @ts-ignore TS2339
        eventType == Microsoft.Office.WebExtension.EventType.BindingDataChanged ||
        // @ts-ignore TS2339
        eventType == Microsoft.Office.WebExtension.EventType.DataNodeDeleted ||
        // @ts-ignore TS2339
        eventType == Microsoft.Office.WebExtension.EventType.DataNodeInserted ||
        // @ts-ignore TS2339
        eventType == Microsoft.Office.WebExtension.EventType.DataNodeReplaced
      ) {
        return id + "_" + eventType;
      } else {
        return eventType;
      }
    };
    export enum UI {}
    export enum ListDescriptors {}
    export enum EventDescriptors {}
    export enum PropertyDescriptors {
      AsyncResultStatus = "AsyncResultStatus",
    }
    export enum DocumentMode {
      ReadOnly = 1,
      ReadWrite = 0,
    }
  }
}

namespace Microsoft {
  export namespace Office {
    export namespace WebExtension {
      export enum Parameters {
        BindingType = "bindingType",
        CoercionType = "coercionType",
        ValueFormat = "valueFormat",
        FilterType = "filterType",
        Columns = "columns",
        SampleData = "sampleData",
        GoToType = "goToType",
        SelectionMode = "selectionMode",
        Id = "id",
        PromptText = "promptText",
        ItemName = "itemName",
        FailOnCollision = "failOnCollision",
        StartRow = "startRow",
        StartColumn = "startColumn",
        RowCount = "rowCount",
        ColumnCount = "columnCount",
        Callback = "callback",
        AsyncContext = "asyncContext",
        Data = "data",
        Rows = "rows",
        OverwriteIfStale = "overwriteIfStale",
        FileType = "fileType",
        EventType = "eventType",
        Handler = "handler",
        SliceSize = "sliceSize",
        SliceIndex = "sliceIndex",
        ActiveView = "activeView",
        Status = "status",
        PlatformType = "platformType",
        HostType = "hostType",
        // OSFJS: Need alternative to pre-processors
        // #ifdef ENABLE_OSFCLIENT_USERIDENTITY
        Email = "email",
        // #endif
        // Add-in SSO
        ForceConsent = "forceConsent",
        ForceAddAccount = "forceAddAccount",
        AuthChallenge = "authChallenge",
        AllowConsentPrompt = "allowConsentPrompt",
        ForMSGraphAccess = "forMSGraphAccess",
        AllowSignInPrompt = "allowSignInPrompt",
        JsonPayload = "jsonPayload",
        EnableNewHosts = "enableNewHosts",
        AccountTypeFilter = "accountTypeFilter",
        AddinTrustId = "addinTrustId",
        Reserved = "reserved",
        Tcid = "tcid",
        // Custom XML Parts
        Xml = "xml",
        Namespace = "namespace",
        Prefix = "prefix",
        XPath = "xPath",
        Text = "text",
        // Image properties
        ImageLeft = "imageLeft",
        ImageTop = "imageTop",
        ImageWidth = "imageWidth",
        ImageHeight = "imageHeight",
        // Project Specific
        TaskId = "taskId",
        FieldId = "fieldId",
        FieldValue = "fieldValue",
        ServerUrl = "serverUrl",
        ListName = "listName",
        ResourceId = "resourceId",
        ViewType = "viewType",
        ViewName = "viewName",
        GetRawValue = "getRawValue",
        CellFormat = "cellFormat",
        TableOptions = "tableOptions",
        TaskIndex = "taskIndex",
        ResourceIndex = "resourceIndex",
        CustomFieldId = "customFieldId",
        // Auth Dialog
        Url = "url",
        MessageHandler = "messageHandler",
        Width = "width",
        Height = "height",
        RequireHTTPs = "requireHTTPS",
        MessageToParent = "messageToParent",
        DisplayInIframe = "displayInIframe",
        MessageContent = "messageContent",
        TargetOrigin = "targetOrigin",
        HideTitle = "hideTitle",
        UseDeviceIndependentPixels = "useDeviceIndependentPixels",
        PromptBeforeOpen = "promptBeforeOpen",
        EnforceAppDomain = "enforceAppDomain",
        UrlNoHostInfo = "urlNoHostInfo",
        Targetorigin = "targetOrigin",
        // AddinCommands
        AppCommandInvocationCompletedData = "appCommandInvocationCompletedData",
        // CreateDocument
        Base64 = "base64",
        // InsertForm
        FormId = "formId",
      }
      export enum FilterType {
        All = "all",
      }

      // ValueFormat represents the formattedness (localized, currency formatted, etc) of an office data value
      export enum ValueFormat {
        Unformatted = "unformatted",
        Formatted = "formatted",
      }

      /// <summary>
      /// Enum that indicates the reason for MOE intialization.
      /// </summary>
      export enum InitializationReason {
        Inserted = "inserted",
        DocumentOpened = "documentOpened",
        ControlActivation = "controlActivation",
      }
    }
  }
}
